/* eslint-disable import/prefer-default-export */

const SIGN_IN_MODAL_SELECTOR = ".js-sign-in-modal";

const $getSignInModal = () => document.querySelector(SIGN_IN_MODAL_SELECTOR);

export const SignInModalUtils = {
  closeModal() {
    const $modalElement = $getSignInModal();
    if ($modalElement && $?.fn?.modal) {
      $($modalElement).modal("hide");
    }
  },

  createSignInButton(text = "Sign In") {
    return `<button
      type="button"
      data-testid="sign-in-toggle-button-from-error"
      data-sign-up-text="${text}"
      class="underline underline-offset-2 js-sign-in-modal-toggle"
    >
      ${text}
    </button>`;
  },

  replaceLoginLinkWithButton(errorMessage) {
    if (!errorMessage || typeof errorMessage !== "string") {
      return this.createSignInButton();
    }

    const signInLinkPattern = /<a[^>]*href=["']\/login["'][^>]*>([^<]+)<\/a>/gi;
    const replacedMessage = errorMessage.replace(signInLinkPattern, (_, linkText) => {
      const buttonText = linkText || "Sign In";
      return this.createSignInButton(buttonText);
    });

    return replacedMessage;
  },

  setGlobal2FAData(data, formAction) {
    Object.assign(window, {
      twoFactorAuthToken: data.authToken,
      rawPhoneNumber: data.rawPhoneNumber,
      twoFactorRedactedPhone: data.phoneNumber,
      twoFactorRedactedEmail: data.email,
      smsEnabled: data.smsEnabled,
      emailEnabled: data.emailEnabled,
      twoFactorRedirectUrl: formAction || undefined
    });
  },

  handleTwoFactorAuth(data, formElement, modalElement) {
    this.setGlobal2FAData(data, formElement.getAttribute("data-redirect-url"));
    $(modalElement).modal("hide");
    window.initTwoFactorModal();
  }
};
